import React, { ReactNode } from 'react';

import { Radio } from '@mui/material';

import classNames from 'classnames';
import classes from './RadioCard.module.scss';
import { SelectableCard } from '../../../../../shared/components/form-components';

type RadioCardProps<T> = {
  value: T;
  checked: boolean;
  onClick: (value: T) => void;
  className?: string;
  children: ReactNode;
};

const RadioCard = <T,>({
  value,
  checked,
  onClick,
  className,
  children,
}: RadioCardProps<T>) => {
  const containerClasses = classNames(classes.container, className);

  const handleClick = () => {
    if (onClick) {
      onClick(value);
    }
  };

  return (
    <SelectableCard variant="outBox" className={containerClasses} onClick={handleClick}>
      <Radio checked={checked} value={value} />
      {children}
    </SelectableCard>
  );
};

export { RadioCard };
